import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-recompose';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { Input, Button, Select } from 'antd';
import { Refresh, Search, ArrowDropDown } from '@material-ui/icons';

const { Option } = Select;

function AgentFilter({
  intl,
  searchText,
  onStateFilter,
  onAvailableFilter,
  onSort,
  onSearch,
  onKeyDownSearch,
  onApplyFilter,
}) {
  const agentStates = [
    { value: 'A', label: intl.formatMessage({ id: 'Active' }) },
    { value: 'I', label: intl.formatMessage({ id: 'Inactive' }) },
  ];
  const agentAvailable = [
    { value: 0, label: intl.formatMessage({ id: 'All availabilities' }) },
    { value: 1, label: intl.formatMessage({ id: 'Available Agents' }) },
    { value: 2, label: intl.formatMessage({ id: 'Unavailable Agents' }) },
  ];
  const agentSorts = [
    { value: 'state desc', label: intl.formatMessage({ id: 'By state' }) },
    { value: 'id desc', label: intl.formatMessage({ id: 'By ID' }) },
    {
      value: 'lastOrderedAt desc',
      label: intl.formatMessage({ id: 'By date of last order placed' }),
    },
  ];
  const handleStateFilter = values => {
    onStateFilter(values);
  };
  const handleAvailalbeFilter = value => {
    onAvailableFilter(value);
  };
  const handleSort = value => {
    onSort(value);
  };

  const handleSearch = e => {
    onSearch(e);
  };

  return (
    <div className="agent_filter_layout">
      <Select
        className="active_states"
        suffixIcon={<ArrowDropDown />}
        mode="multiple"
        placeholder="estados activos"
        onChange={handleStateFilter}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {agentStates.map(item => (
          <Option value={item.value} key={item.label}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Select
        className="availability_by"
        suffixIcon={<ArrowDropDown />}
        placeholder="Disponibilidad"
        onChange={handleAvailalbeFilter}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {agentAvailable.map(item => (
          <Option value={item.value} key={item.label}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Select
        className="sort_by"
        suffixIcon={<ArrowDropDown />}
        placeholder="Ordernar por"
        onChange={handleSort}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {agentSorts.map(item => (
          <Option value={item.value} key={item.label}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Button className="apply_filters_btn" onClick={onApplyFilter}>
        <FormattedMessage id="Apply filters" />
        <Refresh />
      </Button>
      <Input
        suffix={<Search />}
        placeholder="Buscar agente"
        value={searchText}
        onChange={e => handleSearch(e)}
        onKeyDown={e => onKeyDownSearch(e)}
      />
    </div>
  );
}

export default compose(injectIntl)(AgentFilter);
